/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
import {
    Tooltip, Breadcrumb, Button,
} from 'appkit-react';
import {
    Row, Col, Card, Container, Alert,
} from 'react-bootstrap';

import Loader from 'views/Shared/components/Loader';
import DetailsModal from './DetailsModal';
import DataSuggestionContainer from '../containers/DataSuggestionContainer';
import '../styles/index.scss';
import RelationshipChart from './RelationshipChart';

const DataRelationship = ({
    breadcrumbItems, navigateBack, showSuggestionModal,
    loading, onSelect, setShowSuggestionModal, selectedOperation, setSelectedOperation,
    configData, reconNodeId, flowConfig, setFlowConfig, isConfigBuilding,
    setIsConfigBuilding, fileRelationData, showDetailsModal,
    setShowDetailsModal, onShowDetails, selectedRelation, colMatchData,
    navigateToConfigPage, projectId, projectConfig,
}) => {
    const maxStringLength = 17;
    if (loading) {
        return <Loader />;
    }
    return (
        <div className="true-comply-data-relationship_layout">
            <div className="true-comply-data-relationship_column-2">
                <Breadcrumb items={breadcrumbItems} />
                <div className="a-h3 title-label">
                    <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={navigateBack} role="presentation" />
                    Predicted Relationship
                </div>
                <Container fluid className="true-comply-data-relationship_card_container">
                    {/* <Row>
                        <Col>
                            <div className="true-comply-data-relationship_badge">
                                <Badge type="dark" size="medium">TOP MATCHES</Badge>
                            </div>
                        </Col>
                    </Row>
                    <br /> */}
                    {(fileRelationData.length === 0) && <Alert variant="danger">No relationship found.</Alert>}
                    {(fileRelationData.length > 0) && (
                        <Row xs={1} md={3} className="g-4" style={{ paddingLeft: '1.5rem', paddingRight: '1.5rem', paddingTop: '0.5rem' }}>
                            {fileRelationData.map((_, idx) => (
                                <Col key={`card_${idx}`} className="true-comply-data-relationship_card_col" style={{ paddingLeft: 0, paddingRight: 0 }}>
                                    <Card
                                        style={{ width: 'content-fit', marginLeft: '0.5rem', marginRight: '0.5rem' }}
                                        className="mb-2"
                                    >
                                        <Card.Body>
                                            <Row>
                                                <Col md={7}>
                                                    <Row>
                                                        <Col md={1}>
                                                            <span
                                                                className="appkiticon icon-file-outline span-icon"
                                                            />
                                                        </Col>
                                                        <Col style={{ paddingRight: '0' }}>
                                                            <Tooltip
                                                                content={(
                                                                    <span
                                                                        className="a-h5 span-label"
                                                                    >
                                                                        {_.sourceFileDisplayName}
                                                                    </span>
                                                                )}
                                                                placement="top"
                                                                tooltipTheme="light"
                                                            >
                                                                <span
                                                                    className="span-label"
                                                                >
                                                                    {_.sourceFileDisplayName.length <= maxStringLength
                                                                        ? _.sourceFileDisplayName
                                                                        : `${_.sourceFileDisplayName
                                                                            .substr(0, maxStringLength)} ...`}
                                                                </span>
                                                            </Tooltip>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginTop: '0.3rem' }}>
                                                        <Col md={1}>
                                                            <span
                                                                className="appkiticon icon-file-outline span-icon"
                                                            />
                                                        </Col>
                                                        <Col style={{ paddingRight: '0' }}>
                                                            <Tooltip
                                                                content={(
                                                                    <span
                                                                        className="a-h5 span-label"
                                                                    >
                                                                        {_.targetFileDisplayName}
                                                                    </span>
                                                                )}
                                                                placement="top"
                                                                tooltipTheme="light"
                                                            >
                                                                <span
                                                                    className="span-label"
                                                                >
                                                                    {_.targetFileDisplayName.length <= maxStringLength
                                                                        ? _.targetFileDisplayName
                                                                        : `${_.targetFileDisplayName
                                                                            .substr(0, maxStringLength)} ...`}
                                                                </span>
                                                            </Tooltip>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col md={5}>
                                                    <RelationshipChart fileMatchPercentage={_.fileMatchPercentage} index={idx} />
                                                </Col>
                                            </Row>
                                            <Row style={{ marginTop: '-2rem' }}>
                                                <Col md={7}>
                                                    <div className="true-comply-data-relationship_details">
                                                        <Button size="lg" kind="secondary" onClick={() => onShowDetails(_.columnMatch)}>DETAILS</Button>
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div
                                                        className="true-comply-data-relationship_select_button"
                                                    >
                                                        <Button size="lg" kind="primary" onClick={() => onSelect(_)} style={{ marginRight: '0.6rem' }}>SELECT</Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )}
                    {showSuggestionModal && (
                        <DataSuggestionContainer
                            showSuggestionModal={showSuggestionModal}
                            setShowSuggestionModal={setShowSuggestionModal}
                            selectedOperation={selectedOperation}
                            setSelectedOperation={setSelectedOperation}
                            configData={configData}
                            reconNodeId={reconNodeId}
                            flowConfig={flowConfig}
                            setFlowConfig={setFlowConfig}
                            isConfigBuilding={isConfigBuilding}
                            setIsConfigBuilding={setIsConfigBuilding}
                            selectedRelation={selectedRelation}
                            navigateToConfigPage={navigateToConfigPage}
                            projectId={projectId}
                            projectConfig={projectConfig}
                        />
                    )}
                    {showDetailsModal && (
                        <DetailsModal
                            showDetailsModal={showDetailsModal}
                            setShowDetailsModal={setShowDetailsModal}
                            colMatchData={colMatchData}
                        />
                    )}
                </Container>
            </div>
        </div>
    );
};

export default DataRelationship;
